<template>
    <el-dialog title="请选择您喜欢的座右铭"
               :visible.sync="popupMotto.show"
               width="60%"
               :before-close="e => popupMotto.show = false">

        <div class="mottoList">
            <div v-for="(item,index) of popupMotto.motto"
                 :key="index"
                 :class="{active:popupMotto.active == index}"
                 @click="popupMotto.active = index">{{item}}</div>
        </div>

        <span slot="footer"
              class="dialog-footer">
            <el-button type="primary"
                       @click="mottoConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import motto from "./motto.js"
export default {
	data(){
		return{
			popupMotto: {
                show: false,
				motto,
				active:null,
            },
		}
	},
	methods:{
		init(){
			this.popupMotto.show = true
		},
		mottoConfirm(){
			this.popupMotto.show = false
			this.$emit("confirm", this.popupMotto.motto[this.popupMotto.active])
		},
	}
}
</script>

<style lang="scss" scoped>
.mottoList{
	height: 50vh;
	overflow-y: scroll;
	border-top: 1px solid rgba(0, 0, 0, 0.1);
	>div{
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		cursor: pointer;
		&.active{
			background-color: #409EFF;
			color: #fff;
		}
	}
}
</style>